<div class="table-container">
    <div class="table-header pb-3 px-4">
        <div class="header-content">
            <h2 class="table-title">{{ 'app.autopilot_devices.table.title' | translate }}</h2>
            <button mat-icon-button (click)="facade().reload()"
                class="d-flex align-items-center justify-content-center focus-outline-none"
                [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="facade().isLoading()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>

    <div class="table-wrapper" #tableWrapper>
        <table mat-table [dataSource]="dataSource()">
            <ng-container matColumnDef="index">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.index' | translate
                    }}</th>
                <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
            </ng-container>

            <ng-container matColumnDef="serialNumber">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.serial_number' |
                    translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.serialNumber ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="manufacturer">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.manufacturer' |
                    translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.manufacturer ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.model' | translate
                    }}</th>
                <td mat-cell *matCellDef="let row">{{ row.model ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="groupTag">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.group_tag' |
                    translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.groupTag ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="enrollmentState">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.enrollment_state'
                    | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.enrollmentState ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="lastContactedDateTime">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.last_contacted' |
                    translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.lastContactedDateTime ?? '-' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ 'app.autopilot_devices.table.columns.actions' |
                    translate }}</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button color="warn"
                        class="color-error d-flex align-items-center justify-content-center focus-outline-none"
                        [matTooltip]="'app.autopilot_devices.delete.tooltip' | translate" [disabled]="!row.id"
                        (click)="row.id && deleteDevice(row.id)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        @if (dataSource().data.length === 0) {
        <div class="no-data-content mt-5 pt-5">
            @if (facade().isLoading()) {
            <mat-spinner diameter="40"></mat-spinner>
            <span>{{ 'app.autopilot_devices.table.loading' | translate }}</span>
            } @else {
            <span>{{ 'app.autopilot_devices.table.no_data' | translate }}</span>
            }
        </div>
        }

        <app-table-loading-bar [isLoading]="facade().isLoading()"></app-table-loading-bar>
        <div class="bottom-detector" #bottomDetector></div>
    </div>

    <div class="load-more-container">
        @if (!facade().isLoadingMore()) {
        <button mat-flat-button class="load-more-btn d-flex"
            [class.visible]="facade().hasMore() && isBottomReached() && !facade().isLoading()"
            (click)="facade().loadMore()" [disabled]="facade().isLoadingMore()">
            <span>{{ 'app.autopilot_devices.table.load_more' | translate }}</span>
        </button>
        } @else {
        <mat-spinner class="mx-auto" diameter="40" strokeWidth="5"></mat-spinner>
        }
    </div>
</div>